const MainFooter = () => {
    return (
        <footer>
            <div className="inner">
                <div className="f-wr">
                    <p className="logo">
                        <span className="blind">한국벤처캐피탈협회</span>
                    </p>
                    <address>
                        <p>(06247) 서울 강남구 역삼로 177, 팁스타운 6층</p>
                        <p>
                            <span>대표자 : 김학균</span>
                            <span>사업자번호 : 116-82-03540</span>
                        </p>
                        <p>
                            <span>TEL : 02-3017-7091</span>
                            <span>FAX : 02-3474-9244</span>
                        </p>
                        <p>
                            <a href="mailto:edu@kvca.or.kr" style={{ color: '#fff' }}>
                                E-mail: edu@kvca.or.kr
                            </a>
                        </p>
                    </address>
                    <div className="f-lnk">
                        <a href="/m/support/privacy">
                            <b>개인정보처리방침</b>
                        </a>
                        <a href="#">이메일 무단수집거부</a>
                        <a href="/m/support/terms">이용약관</a>
                        <a href="/m/files/attach_cert_duty.pdf" download="붙임.민간자격 표시의무사항.pdf">
                            민간자격 표시의무사항
                        </a>
                        <a href="/m/contactus">Contact Us</a>
                    </div>
                    <div className="f-fam">
                        <a href="javascript:;" className="bt">
                            관련 사이트
                        </a>
                        <ul>
                            <li>
                                <a href="https://edu.kvca.or.kr/" target="_blank">
                                    한국벤처캐피탈연수원
                                </a>
                            </li>
                            <li>
                                <a href="https://ekvci.co.kr/" target="_blank">
                                    KVCA 이러닝센터
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
        // <footer id="footer" className={className}>
        //     <div className="contents">
        //         <a href="#" className="logo">
        //             KVCA한국벤처캐피탈협회
        //         </a>
        //         <ul className="policy">
        //             <li>
        //                 <a href="/m/support/privacy">
        //                     <strong>개인정보처리방침</strong>
        //                 </a>
        //             </li>
        //             <li>
        //                 <a>이메일 무단수집거부</a>
        //             </li>
        //             <li>
        //                 <a href="/m/support/terms">이용약관</a>
        //             </li>
        //             <li>
        //                 <a href="/m/files/attach_cert_duty.pdf" download="붙임. 민간자격 표시의무사항.pdf">
        //                     민간자격 표시의무사항
        //                 </a>
        //             </li>
        //         </ul>
        //         <select name="friend_site" style={{ width: '222px' }}>
        //             <option>관련 사이트</option>
        //             <option>{FRIEND_SITE_KVCA_E_LEARNING}</option>
        //             <option>{FRIEND_SITE_KVCI}</option>
        //         </select>
        //     </div>
        //     <address className="address">
        //         <span>사업자번호 : 116-82-03540</span>
        //         <span>대표자 : 윤건수</span>
        //         <span>TEL : 02-3474-9231</span>
        //         <span>(06595)서울 서초구 서초대로45길 16 한국벤처투자빌딩 2층</span>
        //         <a href="mailto:edu@kvca.or.kr">E-mail: edu@kvca.or.kr</a>
        //         <span>FAX : 02-3474-9244</span>
        //     </address>
        // </footer>
    );
};

export default MainFooter;
